<template>
  <div class="page flex-col login-page">
    <div class="group_1 flex-col">
      <div class="image-wrapper_2 flex-row">
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="/login_lanhu/SketchPngca0c2150fe026ca11384676c79664d7ca11df9bc68fb681147a280c205c2be89.png"
          alt="logo"
          @error="onImgError"
        />
      </div>
      <div class="box_1 flex-row">
        <span class="text_1">welcome&nbsp;to&nbsp;login</span>
        <form class="group_2 flex-col" @submit.prevent="handleSubmit">
          <div class="group_3 flex-col">
            <div class="group_4 flex-col">
              <span class="text_2">欢迎登录</span>
              <div class="box_2 flex-row justify-between">
                <div class="group_6 flex-col" />
                <div class="group_7 flex-col" />
              </div>
              <div class="group_8 flex-row login-input-row">
                <img
                  class="thumbnail_1"
                  referrerpolicy="no-referrer"
                  src="/login_lanhu/SketchPng18f451dcb5c5637625b74d7f88d411f2aee33351f2919b2a8b33c44d2a58df86.png"
                />
                <input
                  v-model="form.username"
                  type="text"
                  class="login-input"
                  placeholder="账号"
                  name="username"
                />
                <span v-show="errors.username" class="login-error">{{ errors.username }}</span>
              </div>
              <div class="group_9 flex-row login-input-row">
                <img
                  class="thumbnail_2"
                  referrerpolicy="no-referrer"
                  src="/login_lanhu/SketchPngd6417be4e699ab7c47af105a923844b5d9f0f06c6a8accb64e7301002b171749.png"
                />
                <input
                  v-model="form.password"
                  type="password"
                  class="login-input"
                  placeholder="密码"
                  name="password"
                />
                <span v-show="errors.password" class="login-error">{{ errors.password }}</span>
              </div>

              <div class="login-slide-wrap">
                <div class="login-slide-box" @selectstart.prevent>
                  <div class="login-slide-bg" :style="{ width: slideWidth + 'px' }" />
                  <div class="login-slide-txt">{{ slideSuccess ? '验证成功' : '滑动解锁' }}</div>
                  <div
                    class="login-slide-slider"
                    :style="{ left: sliderLeft + 'px' }"
                    @mousedown="onSliderStart"
                    @touchstart.prevent="onSliderStartTouch"
                  >
                    <img
                      src="/login/滑动解锁双箭头.png"
                      class="login-slide-arrow"
                      alt=""
                      @error="onSlideArrowError"
                    />
                  </div>
                </div>
              </div>

              <div v-if="apiError" class="login-api-error">{{ apiError }}</div>
              <div class="box_3 flex-row justify-between">
                <div class="image-text_2 flex-row justify-between login-remember">
                  <img
                    class="thumbnail_3"
                    referrerpolicy="no-referrer"
                    src="/login_lanhu/SketchPng6611a711e06f62b80a3377610393d8bd4d4de00795902dbe61035326a5994957.png"
                  />
                  <span class="text-group_1">记住密码</span>
                </div>
                <span class="text_5">忘记密码</span>
              </div>
              <button type="submit" class="text-wrapper_1 flex-col login-btn" :disabled="loading">
                <span class="text_6">{{ loading ? '登录中...' : '登录' }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth.js';
import { login as loginApi } from '@/api/login.js';

const SLIDER_WIDTH = 52;
const SLIDE_BOX_WIDTH = 258;

export default {
  name: 'LanhuLogin',
  data() {
    return {
      form: { username: '', password: '' },
      errors: { username: '', password: '' },
      apiError: '',
      loading: false,
      sliderLeft: 0,
      slideSuccess: false,
      slideWidth: 0,
      isDragging: false,
      startX: 0,
      startLeft: 0
    };
  },
  mounted() {
    if (getToken()) {
      const redirect = this.$route.query.redirect || '/lanhu_fuwushang';
      this.$router.replace(redirect);
    }
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onSliderMove);
    document.removeEventListener('mouseup', this.onSliderEnd);
    document.removeEventListener('touchmove', this.onSliderMoveTouch);
    document.removeEventListener('touchend', this.onSliderEndTouch);
  },
  methods: {
    onSlideArrowError(e) {
      e.target.style.display = 'none';
    },
    validate() {
      this.errors.username = '';
      this.errors.password = '';
      this.apiError = '';
      let valid = true;
      if (!this.form.username || this.form.username === '0') {
        this.errors.username = '账号不能为空';
        valid = false;
      }
      if (!this.form.password || this.form.password === '0') {
        this.errors.password = '密码不能为空';
        valid = false;
      }
      return valid;
    },
    async handleSubmit() {
      if (!this.slideSuccess) return;
      if (!this.validate()) return;
      this.loading = true;
      this.apiError = '';
      try {
        const res = await loginApi(this.form.username, this.form.password);
        if (res.success) {
          const redirect = this.$route.query.redirect || '/lanhu_fuwushang';
          this.$router.push(redirect);
        } else {
          this.apiError = res.message || '登录失败';
        }
      } catch (e) {
        this.apiError = '网络错误，请稍后重试';
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    onImgError(e) {
      e.target.style.display = 'none';
    },
    onSliderStart(e) {
      if (this.slideSuccess) return;
      this.isDragging = true;
      this.startX = e.clientX;
      this.startLeft = this.sliderLeft;
      document.addEventListener('mousemove', this.onSliderMove);
      document.addEventListener('mouseup', this.onSliderEnd);
    },
    onSliderMove(e) {
      if (!this.isDragging) return;
      const dx = e.clientX - this.startX;
      let left = Math.max(0, Math.min(this.startLeft + dx, SLIDE_BOX_WIDTH - SLIDER_WIDTH));
      this.sliderLeft = left;
      this.slideWidth = left + SLIDER_WIDTH;
      if (left >= SLIDE_BOX_WIDTH - SLIDER_WIDTH - 2) {
        this.slideSuccess = true;
        this.onSliderEnd();
      }
    },
    onSliderEnd() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.onSliderMove);
      document.removeEventListener('mouseup', this.onSliderEnd);
      document.removeEventListener('touchmove', this.onSliderMoveTouch);
      document.removeEventListener('touchend', this.onSliderEndTouch);
      if (!this.slideSuccess) {
        this.sliderLeft = 0;
        this.slideWidth = 0;
      }
    },
    onSliderStartTouch(e) {
      if (this.slideSuccess) return;
      this.isDragging = true;
      this.startX = e.touches[0].clientX;
      this.startLeft = this.sliderLeft;
      document.addEventListener('touchmove', this.onSliderMoveTouch, { passive: false });
      document.addEventListener('touchend', this.onSliderEndTouch);
    },
    onSliderMoveTouch(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const dx = e.touches[0].clientX - this.startX;
      let left = Math.max(0, Math.min(this.startLeft + dx, SLIDE_BOX_WIDTH - SLIDER_WIDTH));
      this.sliderLeft = left;
      this.slideWidth = left + SLIDER_WIDTH;
      if (left >= SLIDE_BOX_WIDTH - SLIDER_WIDTH - 2) {
        this.slideSuccess = true;
        this.onSliderEnd();
      }
    },
    onSliderEndTouch() {
      this.onSliderEnd();
    }
  }
};
</script>

<style scoped src="../../assets/login-lanhu.css"></style>
<style scoped>
.login-page .page {
  overflow: visible;
  width: 100%;
}
.login-page {
  min-height: 100vh;
  width: 100%;
}
.group_1 {
  width: 100% !important;
  min-height: 100vh;
  background-size: cover;
  background-position: center;
}
.box_1 {
  margin-left: auto !important;
  margin-right: 15% !important;
  height: auto !important;
  min-height: 426px;
}
.group_2 {
  width: 100%;
  height: auto !important;
  min-height: 426px;
}
.group_3,
.group_4 {
  height: auto !important;
  min-height: 426px;
  overflow: visible;
}
.login-input-row {
  position: relative;
  display: flex;
  align-items: center;
}
.login-input-row .thumbnail_1,
.login-input-row .thumbnail_2 {
  margin: 0 0 0 16px;
  flex-shrink: 0;
}
.login-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  padding: 12px 12px;
}
.login-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.login-error {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 11px;
  color: #dc2626;
}
.login-slide-wrap {
  width: 258px;
  height: 40px;
  margin: 12px 0 0 34px;
  padding: 0;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
}
.login-slide-box {
  position: relative;
  height: 100%;
  user-select: none;
  -webkit-user-select: none;
  margin: 0 2px;
}
.login-slide-bg {
  position: absolute;
  left: 0;
  top: 2px;
  bottom: 2px;
  background: rgba(7, 98, 203, 0.6);
  transition: width 0.1s;
  border-radius: 2px;
}
.login-slide-txt {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
}
.login-slide-slider {
  position: absolute;
  left: 0;
  top: 2px;
  bottom: 2px;
  width: 52px;
  background: rgba(7, 98, 203, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: left 0.05s;
  border-radius: 2px;
}
.login-slide-arrow {
  width: 17px;
  height: 14px;
  pointer-events: none;
}
.login-api-error {
  margin-top: 8px;
  margin-left: 34px;
  font-size: 11px;
  color: #dc2626;
}
.login-remember {
  cursor: pointer;
}
.login-btn {
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.login-btn:hover:not(:disabled) {
  opacity: 0.9;
}
.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.text-wrapper_1 {
  cursor: pointer;
  height: 48px !important;
  min-height: 48px;
}
.text-wrapper_1 .text_6 {
  margin: 0;
}
</style>
